import { render, staticRenderFns } from "./BasePageCard.vue?vue&type=template&id=c448a0bc"
import script from "./BasePageCard.vue?vue&type=script&lang=js"
export * from "./BasePageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports